import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ResearchPage from '../pages/research/page';

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: '/research',
    element: <ResearchPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
